export const WHAT_ARE_COMPASS_COMPONENTS_SUPPORT_URL =
	'https://support.atlassian.com/jira-software-cloud/docs/what-are-compass-components/';

export const WHAT_ARE_JIRA_COMPONENTS_SUPPORT_URL =
	'https://support.atlassian.com/jira-software-cloud/docs/what-are-jira-components/';

export const WHAT_ARE_COMPASS_COMPONENTS_ARTICLE_ID = 'vnkvMTEMH9pGdm5r9sTtl';

export const WHAT_ARE_JIRA_COMPONENTS_ARTICLE_ID = '6PbqxN3PWhkG7F5OE18WqX';
